// extracted by mini-css-extract-plugin
export default {"tooltip":"ap-z","sharingV2":"bp-z","sharingIconsV2":"cp-z","links":"dp-z","link":"ep-z","facebookV2":"fp-z","twitterV2":"gp-z","pinterestV2":"hp-z"};